import React from 'react'
import { Container, Table } from 'react-bootstrap';
import { data } from '../data';
import styles from './Measures.module.scss';

const NQF = () => {
    return (<>

        <Container className='outerContainer'>
            <h1 className="centerText">National Quality Forum (NQF)</h1>
            <h2 className="centerText">Endorsed Individual and Composite Measures</h2>
            <p className='centerText subtitle'>Last updated: May, 2021</p>
        </Container>
        <Container className='outerContainer'>
            <h3>Inpatient Quality Indicators (IQIs) Endorsed by NQF</h3>
            <p className='subtitle'>May, 2021 - AHRQ will no longer seek NQF re-endorsement for its portfolio of measures in the AHRQ Quality Indicators (QIs) program starting in fiscal year 2022. <a href='https://www.qualityindicators.ahrq.gov/Downloads/News/AHRQ_Rationale4notseekingNQFendorsement-May2021.pdf'>Click here for rationale</a>.</p>
            <Table className={styles.nqfTable} striped hover>
                <thead >
                <tr  className='table-heading'>
                        <th >Indicator</th>
                        <th />
                        <th />
                        <th >NQF Number</th>
                    </tr>
                </thead>
                <tbody >
                    {data.NQF.map((information, index) => (<>
                        {information.IQI.map((spec, index) => (
                            <tr>
                                <td ><a href={spec.url}>{spec.indicator}</a></td>
                                <td>{spec.desc}</td>
                                <td>{spec.status}</td>
                                <td>{spec.number}</td>
                            </tr>
                        ))}
                    </>))}
                </tbody>
            </Table>

        </Container>

        <Container className='outerContainer'>
            <h3>Patient Safety Indicators (PSIs) Endorsed by NQF</h3>
            <Table className={styles.nqfTable} striped hover>
                <thead>
                <tr  className='table-heading'>
                        <th >Indicator</th>
                        <th />
                        <th />
                        <th >NQF Number</th>
                    </tr>
                </thead>
                <tbody >
                    {data.NQF.map((information, index) => (<>
                        {information.PSI.map((spec, index) => (<>
                            <tr>
                                <td>{spec.url ? <a href={spec.url}>{spec.indicator}</a> : spec.indicator } </td>
                                <td><span><div dangerouslySetInnerHTML={{ __html: spec.desc }} /></span>
                                </td>

                                <td>{spec.status}</td>
                                <td>{spec.number}</td>
                            </tr>
                        </>
                        ))}
                    </>))}
                </tbody>
            </Table>
            {data.NQF.map((information, index) => (<>
                {information.PSI.map((spec, index) => (<>
                    {spec.footnote ?
                        <ol>
                            <li className={styles.footnote}>{spec.footnote}</li>
                        </ol> : null}
                </>
                ))}
            </>))}
        </Container>

        <Container className='outerContainer'>
            <h3>Pediatric Quality Indicators (PDIs) Endorsed by NQF</h3>
            <Table className={styles.nqfTable} striped hover>
                <thead >
                <tr  className='table-heading'>
                        <th>Indicator</th>
                        <th />
                        <th />
                        <th>NQF Number</th>
                    </tr>
                </thead>
                <tbody >
                    {data.NQF.map((information, index) => (<>
                        {information.PDI.map((spec, index) => (
                            <tr>
                                <td><a href={spec.url}>{spec.indicator}</a></td>
                                <td>{spec.desc}</td>
                                <td>{spec.status}</td>
                                <td>{spec.number}</td>
                            </tr>
                        ))}
                    </>))}
                </tbody>
            </Table>

        </Container>


        <Container className='outerContainer'>
            <h3>Prevention Quality Indicators (PQIs) Endorsed by NQF</h3>
            <Table className={styles.nqfTable} striped hover>
                <thead >
                <tr  className='table-heading'>
                        <th >Indicator</th>
                        <th />
                        <th />
                        <th>NQF Number</th>
                    </tr>
                </thead>
                <tbody >
                    {data.NQF.map((information, index) => (<>
                        {information.PQI.map((spec, index) => (<>
                            <tr>
                                <td><a href={spec.url}>{spec.indicator}</a></td>
                                <td>{spec.desc}</td>
                                <td>{spec.status}</td>
                                <td>{spec.number}</td>
                            </tr>


                        </>))}
                    </>))}
                </tbody>
            </Table>

        </Container>



        <Container className='outerContainer'>
            <h3>Composite Indicators Endorsed by NQF</h3>
            <Table className="NQF-Table">
                <thead >
                    <tr  className='table-heading'>
                        <th >Indicator</th>
                        <th />
                        <th />
                        <th>NQF Number <sup>1</sup></th>
                    </tr>
                </thead>
                <tbody >
                    {data.NQF.map((information, index) => (<>
                        {information.composite.map((comp, index) => (<>
                            <tr className='table-secondary-heading'>
                                <td><a href={comp.url}>{comp.indicator}</a></td>
                                <td><div dangerouslySetInnerHTML={{ __html: comp.desc }} /></td>
                                <td className="danger">{comp.status}</td>
                                <td>{comp.number}</td>
                            </tr>
                            {comp.children.map((child, index) => (<>
                                
                                <tr >
                                    <td  style={{marginLeft: 40, paddingLeft: 40}}><a href={child.url}>{child.indicator}</a></td>
                                    <td >{child.desc}</td>
                                    <td className="danger">{child.status}</td>
                                    <td >{child.number}</td>
                                </tr>
                            </>))}
                        </>))}
                    </>))}
                </tbody>

            </Table>
            <ol>
                <li className={styles.footnote}>Individual measures within each composite that do not have an NQF Number are not individually endorsed by NQF.</li>
                {data.NQF.map((information, index) => (<>
                    {information.composite.map((spec, index) => (<>
                        {spec.footnote ?
                            <li className={styles.footnote}><div dangerouslySetInnerHTML={{ __html: spec.footnote }} /></li>
                            : null}
                    </>
                    ))}
                </>))}
            </ol>
        </Container>


    </>)
}


export default NQF;